'use client';
import { __rest } from 'tslib';
import React, { forwardRef, useRef, useCallback } from 'react';
import { useEdit } from '../hooks/useEdit.js';
import { debounce, isNil, round } from 'lodash';
import { Input } from './Input.js';
import { useOutsideAlerter } from '../hooks/useOutsideAlerter.js';

const castNumberString = (s) => (typeof s !== 'string' && typeof s !== 'number') ? '' : s.toString();
// export const NumberInputNative = forwardRef<HTMLInputElement, InputProps>((props, forwardedRef) => {
//     <span>
//         <Input
//             ref={forwardedRef}
//             {...props}
//             />
//     </span>
// })
// TODO: allow decimal values, what does size even do??? not in use currently
const NumberInput = forwardRef((_a, forwardedRef) => {
    var { children, label, error, onChange, value, id, min, max, precision, integerOnly, size, allowUndefined, debounceWait = 5000 } = _a, props = __rest(_a, ["children", "label", "error", "onChange", "value", "id", "min", "max", "precision", "integerOnly", "size", "allowUndefined", "debounceWait"]);
    const [state, setState, revert] = useEdit(value !== null && value !== void 0 ? value : '');
    if (integerOnly) {
        precision = 0;
    }
    const calculateChange = (val) => {
        const int = precision !== undefined ? round(parseFloat(val), precision) : parseFloat(val);
        if (allowUndefined && !val) {
            return undefined;
        }
        if (max !== undefined && int > max) {
            return max;
        }
        if (min !== undefined && int < min) {
            return min;
        }
        if (!val || Number.isNaN(int)) {
            return 'revert';
        }
        return int;
    };
    const handleChangeDebounced = (val) => {
        const newValue = calculateChange(val);
        if (newValue === 'revert') {
            revert();
            return;
        }
        setState(newValue);
        // @ts-expect-error
        onChange(newValue);
    };
    const ref = forwardedRef || useRef(null);
    const outsideCallback = useCallback(() => handleChangeDebounced(castNumberString(state)), [min, max, onChange, state]);
    useOutsideAlerter(ref, outsideCallback);
    const debouncedChangeHandler = useCallback(debounce(handleChangeDebounced, debounceWait), [min, max, onChange]);
    const handleChange = (e) => {
        setState(e.target.value);
        debouncedChangeHandler(e.target.value);
    };
    return (React.createElement("span", null,
        React.createElement(Input, Object.assign({ label: label, ref: ref, min: min && min - 10, max: max && max + 10, onChange: handleChange, type: "number", value: state !== null && state !== void 0 ? state : '', id: id, step: !isNil(precision) ? Math.pow(10, (-1 * precision)) : "any" }, props))));
});
NumberInput.displayName = 'NumberInput';

export { NumberInput };
